import styled from '@emotion/styled';
import { BaseButton, Variables } from '../../base';

export const DialogBody = styled.div`
    display: flex;
    flex-direction: column;
    flex: 1;
    width: 100%;
    min-height: 100%;
    background: ${Variables.Colors.n15};
`;

export const Toolbar = styled.div`
    position: sticky;
    top: 0;
    z-index: 2;
    display: flex;
    align-items: center;
    gap: 12px;
    padding: 12px 20px;
    background: ${Variables.Colors.n100};
`;

export const ToolbarTitle = styled.span`
    font-size: 14px;
    font-weight: 600;
    color: ${Variables.Swatches.White};
`;

export const ToolbarActions = styled.div`
    margin-left: auto;
    display: flex;
    gap: 10px;
    align-items: center;
`;

export const ToolbarGhostButton = styled(BaseButton)`
    height: 36px;
    padding: 0 14px;
    background: transparent !important;
    border: 1px solid rgba(255, 255, 255, 0.3) !important;
    color: ${Variables.Swatches.White} !important;
    border-radius: 8px;
`;

export const ToolbarPrimaryButton = styled(BaseButton)`
    height: 36px;
    padding: 0 16px;
    display: inline-flex;
    align-items: center;
    gap: 6px;
    background: ${Variables.Colors.b300} !important;
    border: none !important;
    color: ${Variables.Swatches.White} !important;
    border-radius: 8px;
`;

export const PaperWrap = styled.div`
    padding: 28px 0 56px;
`;

export const PaperShadow = styled.div`
    width: 816px;
    max-width: 94vw;
    margin: 0 auto;
    background: ${Variables.Swatches.White};
    box-shadow: 0 12px 40px rgba(21, 29, 43, 0.18);
    overflow: hidden;
`;

export const PreviewFrame = styled.iframe`
    display: block;
    width: 100%;
    min-height: 1100px;
    border: none;
    background: ${Variables.Swatches.White};
`;
